import React, { Component } from 'react'

 class Socials extends Component {
  render() {
    return (
        <div className="bg-black">
        <div className="p-2 d-flex justify-content-center gap-5">
          <a href='#'><i class="bi bi-facebook text-white fs-2"></i></a>
          <a href='#'><i class="bi bi-instagram text-white  fs-2"></i></a>
          <a href='#'><i class="bi bi-tiktok text-white fs-2"></i></a>
        </div>
      </div>
    )
  }
}

export default Socials;